<span class="ui-float-label" style="margin-bottom: 20px;">
    <input id="name-input" type="text" pInputText [(ngModel)]="prepaidModel.amount" currencyMask [options]="{ prefix: '', suffix: ' zł ', thousands: '.', decimal: ',' }">
    <label for="name-input">Kwota doładowania</label>
</span>
<button pButton [label]="'Zapisz'" (click)="save()"></button>